module.exports = __webpack_public_path__ + "img/FirstPurchaseTitle.548c24b8.png";